<template>
  <div class="app-personal-data-change-success">
    <slot name="beforePersonalData">Ihre persönlichen Daten wurden erfolgreich geändert.</slot>
    <ShowPersonalData :customer="currentCustomer"></ShowPersonalData>
    <Stepper
      :show-prev="false"
      @next="nextView()"
    >
      <template #btnNext><slot name="btnNext">ändern</slot></template>
    </Stepper>
  </div>
</template>

<script>
import { wrapQuery } from '@/helper/wrapGQLQuery'
import gql from 'graphql-tag'
import { mapMutations } from 'vuex'
import ShowPersonalData from '@/components/process/generic/PersonalData/ShowPersonalData.vue'
import Stepper from '@/components/generic/Stepper.vue'
import { stepName as nextProcessStep } from '@/components/process/generic/PersonalData/Change.vue'
import processSteps from '../../../../mixins/processSteps'
export const stepName = 'successPersonalData'
export default {
  name: 'PersonalDataChangeSuccess',
  data () {
    return {
      currentCustomer: {
        salutation: '',
        firstName: '',
        lastName: '',
        birthDate: '',
        address: {
          city: '',
          houseNumber: '',
          street: '',
          supplement: '',
          zip: ''
        },
        email: ''
      }
    }
  },
  computed: {
  },
  components: { ShowPersonalData, Stepper },
  mixins: [
    processSteps(stepName, stepName, nextProcessStep)
  ],
  methods: {
    ...mapMutations('personalData', [
      'changeView'
    ]),
    nextView () {
      this.changeView(nextProcessStep)
    }
  },
  apollo: {
    currentCustomer: function () {
      return wrapQuery(
        gql`query personalData {
          currentCustomer {
            salutation,
            firstName,
            birthDate,
            lastName,
            address {
              city,
              houseNumber,
              street,
              supplement,
              zip
            },
            email
          }
        }`, this, 'currentCustomer', {}, null,
        {
          fetchPolicy: 'cache-and-network'
        }
      )
    }
  }
}
</script>
